import { type DsIconName } from '@frontends/ds-icons';
import { type UserAgentInfo } from '@/types/Auth.ts';

const BROWSER_ICONS: Partial<Record<string, DsIconName>> = {
  Chrome: 'brand-chrome',
  Edge: 'brand-edge',
  Firefox: 'brand-firefox',
  Opera: 'brand-opera',
  Safari: 'brand-safari',
};

const getDeviceName = ({ platform, os }: UserAgentInfo): string => {
  if (platform === 'Macintosh') return 'Mac';

  if (os.startsWith('Android')) return 'Android';

  if (os.startsWith('CrOS')) return 'ChromeOS';

  if (platform === 'X11') return 'Linux';

  return platform;
};

export const getBrowserName = ({ browser, browser_version: browserVersion }: UserAgentInfo): string => {
  const majorVersion = browserVersion.split('.')[0];

  return browser && majorVersion ? `${browser} ${majorVersion}` : browser;
};

export const getBrowserIcon = (userAgent?: UserAgentInfo): DsIconName =>
  (userAgent && BROWSER_ICONS[userAgent.browser]) ?? 'globe';

export const getSessionTitle = (userAgent?: UserAgentInfo): string =>
  userAgent ? [getDeviceName(userAgent), getBrowserName(userAgent)].filter(Boolean).join(' · ') : '';
